import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d263a3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entity" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_4 = { class: "the-quill-editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vue_quill = _resolveComponent("vue-quill")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.content !== null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "success",
              onClick: _ctx.onSave
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_vue_quill, {
              contentType: "html",
              content: _ctx.content,
              "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event))
            }, null, 8, ["content"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.content === null]
  ])
}